import { render, staticRenderFns } from "./Hdjl.vue?vue&type=template&id=664d2a20&scoped=true"
import script from "./Hdjl.vue?vue&type=script&lang=js"
export * from "./Hdjl.vue?vue&type=script&lang=js"
import style0 from "./Hdjl.vue?vue&type=style&index=0&id=664d2a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d2a20",
  null
  
)

export default component.exports